// modules/navToggle.js

export function init() {
    const toggle = document.getElementById('nav-toggle');
    const panel  = document.getElementById('nav-panel');

    if (!toggle || !panel) return;

    const lang = toggle.closest('.nav').querySelector('.nav__lang');

    toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', String(!isOpen));
        panel.setAttribute('aria-hidden', String(isOpen));
        toggle.closest('.nav').classList.toggle('nav--open', !isOpen);
        if (lang) lang.setAttribute('aria-hidden', String(isOpen));
    });
}

export function destroy() {
    // Rien à nettoyer (listener attaché à un élément persistant)
}
